import { loadEnvConfig } from '_/env-config';

(async () => {
  // First load the env/config.json file so we know which environment we are in.
  await loadEnvConfig();

  // Dynamic import to avoid bundling i18n config into main entry chunk
  const { i18nInitPromise } = await import('_/i18n/config');
  await i18nInitPromise;

  // After loading the env/config.json boot the application.
  await import('_/app/app-boot');
})();
